<template>
    <div>
        <navbar-header page-name="Доставка"></navbar-header>
        <CourierDelivery @updated-payment="updatedPayment" class="flex-grow-1"></CourierDelivery>
    </div>
</template>

<script>
import NavbarHeader from '@/components/NavbarHeader'
import CourierDelivery from '@/components/CourierDelivery'
export default {
  name: 'CourierDeliverylayout',
  data () {
    return {
    }
  },
  methods: {
    updatedPayment () {
      console.log('welcome')
    }
  },
  components: {
    CourierDelivery,
    NavbarHeader
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CourierDeliveryLayout.vue